// Builds Dynamic Image Transformation URLs from a source key. When no CDN base
// is configured (VITE_IMAGE_CDN_BASE unset), returns the key unchanged so the
// app degrades to a plain <img src> — inert until Phase 3 infra is live.
export const IMAGE_CDN_BASE: string =
  (import.meta.env?.VITE_IMAGE_CDN_BASE as string | undefined) ?? "";

export function imageUrl(
  key: string,
  opts: { width: number; format?: "auto" },
  base: string = IMAGE_CDN_BASE,
): string {
  if (!base) return key;
  return `${base}/fit-in/${opts.width}x0/${key}`;
}

export function buildSrcSet(
  key: string,
  widths: number[],
  base: string = IMAGE_CDN_BASE,
): string {
  return widths.map((w) => `${imageUrl(key, { width: w }, base)} ${w}w`).join(", ");
}
